import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "react-tooltip";

const CostEstimationBanner = () => {
  return (
    <div className="w-full my-4 bg-yellow-100 border border-yellow-300 text-yellow-800 px-4 py-3 rounded-lg flex items-center gap-2 relative">
      <strong className="font-semibold">Estimates Only:</strong>
      <span>
        All displayed costs are estimates and may not reflect the actual
        invoice.
      </span>

      <InformationCircleIcon
        id="estimation-icon"
        className="h-5 w-5 text-yellow-600"
      />
      <Tooltip
        anchorSelect={"#estimation-icon"}
        content={"Your invoice will reflect the actual amount charged."}
        place="bottom-end"
      />
    </div>
  );
};

export default CostEstimationBanner;
